export const apiConstants = {
  url: "/api/doortype",
  typecategory: "/api/typecategory",
  frame: "/api/frame",
  numberrange: "/api/numberrange",
  wallconnection: "/api/wallconnection",
  udtable: "/api/udtable",
  rulegroup: "/api/rulegroup",
  item: "/api/item",
  itemcategory: "/api/itemcategory",
  component: "/api/component",
  extract: "/api/extract",
  tags: "/api/tags",
  edgespacer: "/api/edgespacer",
  countries: "/api/country",
  labeltypes: "/api/labeltype"
};
